import React from "react";
import { ProfileRow } from "../ProfileRow";
import { getVerificationStatus } from "../../utils/profileFormatters";
import { useTranslation } from "@helpers/translate";
import { useNavigate } from "react-router-dom";
import { PROFILE_VERIFICATION_PAGE } from "@constants";
import ArrowRightIcon from "@assets/icons/ArrowRightIcon";

import "./index.sass";

const hasTextValue = (value) =>
  typeof value === "string" &&
  Boolean(value.trim());

export const VerificationRow = ({
  ondato_status,
  is_user_verified,
  submission,
  first_name,
  last_name,
  country,
  date_birth,
}) => {
  const { __ } = useTranslation();
  const navigate = useNavigate();

  const verificationCanBeStarted =
    ondato_status === 1 ||
    ondato_status === 4;

  const missingFields = [
    !hasTextValue(first_name)
      ? __("verification.step1.firstName")
      : null,

    !hasTextValue(last_name)
      ? __("verification.step1.lastName")
      : null,

    !hasTextValue(country)
      ? __("verification.step1.country")
      : null,

    !hasTextValue(date_birth)
      ? __("profile.date_of_birth")
      : null,
  ].filter(Boolean);

  const hasAllRequiredData =
    missingFields.length === 0;

  const missingDataNotice = !hasAllRequiredData ? (
    <p className="verification-row__notice-text">
      <span>
        {__(
          "profile.verification_missing_data",
        )}
      </span>{" "}
      <span className="verification-row__notice-fields">
        {missingFields.join(", ")}
      </span>
      .
    </p>
  ) : null;

  const handleVerificationClick = () => {
    if (!hasAllRequiredData) {
      return;
    }

    navigate(PROFILE_VERIFICATION_PAGE);
  };

  return (
    <ProfileRow
      label={__("profile.verification_kyc")}
      notice={missingDataNotice}
      value={
        hasAllRequiredData
          ? getVerificationStatus(
              ondato_status,
              __,
              submission,
              is_user_verified,
            )
          : null
      }
      actions={
        hasAllRequiredData &&
        verificationCanBeStarted ? (
          <button
            type="button"
            className="profile-action__button"
            onClick={handleVerificationClick}
          >
            {__(
              "profile.verification_kyc_get",
            )}

            <ArrowRightIcon />
          </button>
        ) : null
      }
    />
  );
};
